import i18n from 'locales/i18n';
import { HelmetProvider } from 'react-helmet-async';
import toast, { ToastBar, Toaster } from 'react-hot-toast';
import { I18nextProvider } from 'react-i18next';
import { IChildrenProp } from 'types/components/components.interface';
import { toastOptions } from 'utils';
import ConfigurationProvider from './ConfigurationProvider';
import { ConnectionProvider } from './ConnectionContext';
import QueryProvider from './QueryProvider';
import { StoreStateProvider } from './StoreStateContext';
import ThemeProvider from './ThemeProvider';

interface IAppProvidersProps extends IChildrenProp {}

const AppProviders = ({ children }: IAppProvidersProps) => {
  return (
    <StoreStateProvider>
      <QueryProvider>
        <ThemeProvider>
          <HelmetProvider>
            <I18nextProvider i18n={i18n}>
              <ConfigurationProvider>
                <ConnectionProvider>
                  <Toaster
                    position="bottom-right"
                    reverseOrder={false}
                    gutter={10}
                    containerClassName="toast-wrapper"
                    containerStyle={{ inset: 30 }}
                    toastOptions={toastOptions}
                  >
                    {(t) => (
                      <div onClick={() => toast.dismiss(t.id)}>
                        <ToastBar toast={t} />
                      </div>
                    )}
                  </Toaster>

                  {children}
                </ConnectionProvider>
              </ConfigurationProvider>
            </I18nextProvider>
          </HelmetProvider>
        </ThemeProvider>
      </QueryProvider>
    </StoreStateProvider>
  );
};

export default AppProviders;
